import {
  CompanyResponse,
  NoneOrderDocumentClassDto,
  NoneOrderTagDetailResponse,
  TagCategoryTagDto,
} from "apis/data-contracts";
import { TempDocumentDetailResponseWithAny } from "../queries/useTempDocumentDetailQuery";
import { useRecoilState } from "recoil";
import {
  selectedWorkCompanyState,
  selectedWorkDocumentClassState,
  selectedWorkPjTagState,
  selectedWorkTopicTagsState,
} from "store/document/workDocument";
import {
  getCompanyTagFromTempDoc,
  getPjTagFromTempDoc,
  getTopicTagFromTempDoc,
} from "features/document/utils/getTag";

const useWorkSelectFormStates = () => {
  const [selectedCompany, setSelectedCompany] = useRecoilState(
    selectedWorkCompanyState,
  );
  const [selectedPj, setSelectedPj] = useRecoilState(selectedWorkPjTagState);
  const [selectedDocumentClass, setSelectedDocumentClass] = useRecoilState(
    selectedWorkDocumentClassState,
  );
  const [selectedTopics, setSelectedTopics] = useRecoilState(
    selectedWorkTopicTagsState,
  );

  const onSelectCompany = (company: CompanyResponse) => {
    setSelectedCompany({
      uuid: company.uuid,
      name: company.name,
    });
  };

  const onSelectPj = (pj: TagCategoryTagDto) => {
    setSelectedPj((prev) => {
      return prev?.tagUuid !== pj.uuid
        ? { tagName: pj.name, tagUuid: pj.uuid }
        : undefined;
    });
  };

  const onSelectDocumentClass = (documentClass: NoneOrderDocumentClassDto) => {
    setSelectedDocumentClass(documentClass);
  };

  const onSelectTopic = (tag?: NoneOrderTagDetailResponse) => {
    if (!tag) return;

    let newTopics: NoneOrderTagDetailResponse[];

    if (selectedTopics.some((topic) => topic?.tagUuid === tag?.tagUuid)) {
      newTopics = selectedTopics.filter(
        (topic) => topic?.tagUuid !== tag?.tagUuid,
      );
    } else {
      newTopics = [...selectedTopics, tag];
    }

    setSelectedTopics(newTopics);
  };

  const setWorkSelectStatesUsingTempDoc = (
    tempDocumentDetail: TempDocumentDetailResponseWithAny,
  ) => {
    const savedDocumentClass: NoneOrderDocumentClassDto = {
      uuid: tempDocumentDetail.documentClassUuid,
      name: tempDocumentDetail.documentClassName,
    };
    const savedComapnyTag = getCompanyTagFromTempDoc(tempDocumentDetail);
    const savedPjTag = getPjTagFromTempDoc(tempDocumentDetail);
    const savedTopicTags = getTopicTagFromTempDoc(tempDocumentDetail);

    setSelectedDocumentClass(savedDocumentClass);
    if (savedComapnyTag)
      setSelectedCompany({
        uuid: savedComapnyTag.tagUuid,
        name: savedComapnyTag.tagName,
      });
    if (savedPjTag) setSelectedPj(savedPjTag);
    if (savedTopicTags.length > 0) setSelectedTopics(savedTopicTags);
  };

  return {
    selectedCompany,
    setSelectedCompany,
    onSelectCompany,

    selectedPj,
    setSelectedPj,
    onSelectPj,

    selectedDocumentClass,
    setSelectedDocumentClass,
    onSelectDocumentClass,

    selectedTopics,
    setSelectedTopics,
    onSelectTopic,

    setWorkSelectStatesUsingTempDoc,
  };
};

export default useWorkSelectFormStates;
